import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { getApi } from './api'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist'
import { Persistor } from 'redux-persist/es/types'
import { service } from './service'
import { defaultSubscriptionIdSlice } from './services/useDefaultSubscription'
import { RedirectSlice } from './services/useRedirect'
import { devSettingsSlice } from './services/useDevSettings'
import { userDataSlice } from './services/useUserData'
import { userAnalyticsSlice } from './services/useUserAnalytics'
import { thingSlice } from './services/useThing'
import { kycStepSlice } from './services/useKycStep'
import { selectedMailsSlice } from './services/useSelectedMails'
import { offerRedemptionUrlsSlice } from './services/useOfferRedemptionUrl'

// END OF IMPORTS
const createStore = () => {
  const storage =
    getApi().reduxStorage ||
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require('redux-persist/lib/storage').default
  const reducer = combineReducers({
    [service.reducerPath]: service.reducer,
    defaultSubscriptionId: defaultSubscriptionIdSlice.reducer,
    devSettings: devSettingsSlice.reducer,
    kycStep: kycStepSlice.reducer,
    offerRedemptionUrls: offerRedemptionUrlsSlice.reducer,
    redirect: RedirectSlice.reducer,
    selectedMails: selectedMailsSlice.reducer,
    thing: thingSlice.reducer,
    userAnalytics: userAnalyticsSlice.reducer,
    userData: userDataSlice.reducer,
    // END OF REDUCERS
  })

  return configureStore({
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      })
        .concat(service.middleware)
        // END OF MIDDLEWARE
        .concat(getApi().middlewares || []),
    // @ts-ignore typescript is confused by the turnary
    reducer:
      typeof window !== 'undefined'
        ? persistReducer(
            {
              key: 'root',
              storage,
              version: 1,
              whitelist: [
                'service',
                'userData',
                'devSettings',
                'userAnalytics',
                'defaultSubscriptionId',
              ],
            },
            reducer,
          )
        : reducer,
  })
}

type StoreType = ReturnType<typeof createStore>
let _store: StoreType
let _persistor: Persistor
export const getPersistor = () => _persistor
export const getStore = function (): StoreType {
  if (_store) return _store
  _store = createStore()
  _persistor = persistStore(_store)
  return _store
}

export type StoreStateType = ReturnType<StoreType['getState']>
